import React from 'react';
import { useSearchSort } from '../../components/kitsters/useSearchSort';

const TableItem = ({ itemdata }) => {
  const { view, query, setQuery, sortKey, sortDir, toggleSort } = useSearchSort(itemdata);

  const rows = [];
  for (let i = 0; i < view.length; i++) {
    const a = view[i];
    rows.push(
      <tr key={a._id || i}>

        <td>{a.name}</td>
        <td>{a.unit}</td>
        <td>{a.vendor_name}</td>
        
        <td>{a.available_for_sale_stock || a.stock_on_hand}</td>
        <td>{a.actual_available_for_sale_stock || a.available_stock}</td>
        <td>
          <a href={`https://books.zoho.in/app/60022040726#/inventory/items/${a.item_id}`} target="_blank">view</a>
        </td>
      </tr>
    );
  }

  const th = (key: string, label: string) => (
    <th className="th-sort" onClick={() => toggleSort(key)}>
      {label} {sortKey === key ? (sortDir === 'asc' ? '▲' : '▼') : ''}
    </th>
  );

  return (
    <>
      <input className="tbl-search" placeholder="Search…" value={query} onChange={e => setQuery(e.target.value)} />
      <table className="grid">
        <thead>
          <tr>
            {th('name', 'name')}
            {th('unit', 'unit')}

            {th('unit', 'vendor')}
            

            {th('stock_on_hand', 'accounting stock')}
            {th('available_stock', 'physical stock')}
            <th style={{ width: '30px' }}>action</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </>
  );
};

export default TableItem;
